import React from "react";

function DeleteAccountIcon({ size = 23 }) {
  const width = (20 / 23) * size;

  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.40566 9.67078C9.30566 9.66078 9.18566 9.66078 9.07566 9.67078C6.69566 9.59078 4.80566 7.64078 4.80566 5.24078C4.80566 2.84078 6.78566 0.800781 9.24566 0.800781C11.7057 0.800781 13.6857 2.79078 13.6857 5.24078C13.6757 7.64078 11.7857 9.59078 9.40566 9.67078Z"
        stroke="#FF3C3C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.40566 9.67078C9.30566 9.66078 9.18566 9.66078 9.07566 9.67078C6.69566 9.59078 4.80566 7.64078 4.80566 5.24078C4.80566 2.84078 6.78566 0.800781 9.24566 0.800781C11.7057 0.800781 13.6857 2.79078 13.6857 5.24078C13.6757 7.64078 11.7857 9.59078 9.40566 9.67078Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5448 14.2313C12.1348 12.3213 6.5048 12.3213 3.0648 14.2313C0.0448046 15.9213 0.0448046 18.6813 3.0648 20.3613C5.3248 21.6213 8.5248 22.0613 11.4248 21.6613"
        stroke="#FF3C3C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5448 14.2313C12.1348 12.3213 6.5048 12.3213 3.0648 14.2313C0.0448046 15.9213 0.0448046 18.6813 3.0648 20.3613C5.3248 21.6213 8.5248 22.0613 11.4248 21.6613"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5557 16.7109L19.2157 21.3709"
        stroke="#FF3C3C"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5557 16.7109L19.2157 21.3709"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2157 16.7109L14.5557 21.3709"
        stroke="#FF3C3C"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2157 16.7109L14.5557 21.3709"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DeleteAccountIcon;
